export default function ErrorApp() {
  return (
    <p>There is an error loading the app.</p>
  );
}
